import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getCRMList } from './api';

export interface ICRMData {
  _id: string;
  username?: string;
  firstname?: string;
  lastname?: string;
  phoneNumber?: string;
  email?: string;
  createdAt?: string;
  lastClassDate?: string;
  nextClassDate?: string;
  availableCreditsAccount?: number;
  availableCreditsCourse?: number;
  country?: string;
  numberOfEnrolledCourses?: number;
  numberOfTrialCourses?: number;
  numberOfPayments?: number;
  lastPaymentDate?: string;
  lastPaymentAmount?: number;
  lastPaymentCurrency?: string;
}

export interface ICRMListResponse {
  offset: number;
  limit: number;
  totalDocs: number;
  docs: Array<ICRMData>;
}

export interface ICRMState {
  crmList: ICRMListResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: ICRMState = {
  crmList: null,
  loading: false,
  error: null,
};

const crmSlice = createSlice({
  name: 'crm',
  initialState,
  reducers: {
    clearCRMState: (state) => {
      state.crmList = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCRMList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getCRMList.fulfilled,
        (state, action: PayloadAction<ICRMListResponse>) => {
          state.loading = false;
          state.crmList = action.payload;
          state.error = null;
        }
      )
      .addCase(getCRMList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch CRM data';
      });
  },
});

export const { clearCRMState } = crmSlice.actions;
export default crmSlice.reducer;

export const getCRMState = (state: { crm: ICRMState }) => state.crm;

// Export API actions
export { getCRMList } from './api';
export type { TGetCRMList } from './api';
